import React, {FC, useEffect, useState} from 'react';

import statsApi from '../../api/allInclusive/stats';

type AllInclusivePlacesCounterProps = {
  title?: string;
  description?: string;
  variant?: 'card' | 'inline';
}

const AllInclusivePlacesCounter: FC<AllInclusivePlacesCounterProps> = ({
  title = 'Platser hos företag',
  description = 'Totalt antal platser som vi hittat hos företag i All Inclusive.',
  variant = 'card',
}) => {
  const [totalPlaces, setTotalPlaces] = useState<number | null>(null);
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    statsApi.fetchAllInclusiveStats()
        .then((data) => {
          setTotalPlaces(data.total_places ?? 0);
        })
        .catch(() => {
          setTotalPlaces(0);
        });
  }, []);

  useEffect(() => {
    if (totalPlaces == null) return;

    const duration = 1200;
    const start = performance.now();

    const animate = (now: number) => {
      const progress = Math.min((now - start) / duration, 1);
      setDisplayValue(Math.floor(totalPlaces * progress));
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [totalPlaces]);

  if (totalPlaces == null) {
    return null;
  }

  if (variant === 'inline') {
    return (
      <div className='border-t border-black/10 pt-6'>
        <p className='text-pink-primary uppercase font-semibold tracking-wide text-sm'>{title}</p>
        <p className='text-5xl lg:text-6xl font-bold text-black-dark mt-2'>{displayValue}</p>
        <p className='text-black-dark/70 text-base lg:text-lg mt-2'>
          {description}
        </p>
      </div>
    );
  }

  return (
    <div className='w-full py-12'>
      <div
        className={
          'bg-white rounded-15px shadow-addCard px-8 py-10 flex flex-col ' +
          'items-center text-center max-w-3xl mx-auto'
        }
      >
        <p className='text-pink-primary uppercase font-semibold tracking-wide text-sm'>{title}</p>
        <p className='text-6xl lg:text-7xl font-bold text-black-dark mt-4'>{displayValue}</p>
        <p className='text-black-dark/70 text-base lg:text-lg mt-4 max-w-xl'>
          {description}
        </p>
      </div>
    </div>
  );
};

export default AllInclusivePlacesCounter;
